<template>
  <span>{{ label }}</span>
</template>
<script setup>
import { ref, defineProps, getCurrentInstance, computed, watch } from 'vue'
const props = defineProps({
  dictKey: { type: String, required: true },
  modelValue: { type: String, required: true },
  dictType: { type: Number, default: 1 }
})
const { proxy } = getCurrentInstance()
const label = ref('')
const dictUrl = computed(() => {
  return `/app/custClient/dict/val/${props.dictKey}/${props.modelValue}`
})
const getData = async () => {
  let orgId = props.dictType === 2 ? localStorage.getItem('orgId') : null
  let res = await proxy.$http.post('/app/custClient/dict/val', { orgId: orgId, code: props.dictKey, type: props.modelValue })
  if (res.code === 0) {
    label.value = res.data?.dictValue
  }
}
watch(
  () => props.modelValue,
  (newVal) => {
    label.value = ''
    if (newVal) {
      getData()
    }
  },
  { immediate: true }
)
</script>
